import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { progressSelectorFactory } from 'src/common/store/selectors';
import { RootState } from 'src/store';
import { Fees } from './components/fees';
import {
  fetchAfsls,
  fetchTemplates,
  duplicateTemplate,
  feesSlice,
  selectAfslId,
  selectAfsls,
  selectTemplates,
  TemplateFeesActionTypes,
  grandfatherTemplate,
  createTemplate,
  updateTemplate,
} from './store';
import { fetchAssetClasses } from 'src/common/store/thunks';

const mapStateToProps = (state: RootState) => ({
  afslId: selectAfslId(state),
  afsls: selectAfsls(state),
  templates: selectTemplates(state),
  fetchTemplatesProgress: progressSelectorFactory([TemplateFeesActionTypes.FetchTemplates])(state),
  duplicateTemplateProgress: progressSelectorFactory([TemplateFeesActionTypes.DuplicateTemplate])(state),
  grandfatherTemplateProgress: progressSelectorFactory([TemplateFeesActionTypes.GrandfatherTemplate])(state),
  manageTemplateProgress: progressSelectorFactory([TemplateFeesActionTypes.ManageTemplate])(state),
});

interface MatchParams {
  afslId: string;
}

const mapDispatchToProps = {
  fetchAfsls,
  fetchTemplates,
  fetchAssetClasses,
  duplicateTemplate,
  grandfatherTemplate,
  createTemplate,
  updateTemplate,
  ...feesSlice.actions,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector> & RouteComponentProps<MatchParams>;
export const FeesContainer = connect(mapStateToProps, mapDispatchToProps)(Fees);
